import {createContext} from 'react';

import {observer} from 'mobx-react-lite';

import {useGlobalFormData} from './useGlobalFormData';

import type {FormDataContextType} from 'Shared/formHelperTypes';
import type {WithChildren} from 'types/global';

export const FormsDataContext = createContext<FormDataContextType | null>(null);

const GlobalFormProvider = observer(({children}: WithChildren) => {
    const {formsDataContext} = useGlobalFormData();

    return (
        <FormsDataContext.Provider value={formsDataContext}>
            {children}
        </FormsDataContext.Provider>
    );
});

GlobalFormProvider.displayName = 'GlobalFormProvider';

export {GlobalFormProvider};